type ExtendedWindow = Window & {
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    gtag: (...args: any[]) => void;
};

export function conversion(conversionID: string, dsn?: string) {
    const extendedWindow = (window as unknown) as ExtendedWindow;
    extendedWindow.gtag("event", "conversion", {
        send_to: `${process.env.REACT_APP_GOOGLE_ANALYTICS_ID}/${conversionID}`,
        transaction_id: dsn ? dsn : "",
    });
}

export function pageView(location: string, path: string, title: string) {
    const extendedWindow = (window as unknown) as ExtendedWindow;
    extendedWindow.gtag("event", "page_view", {
        page_location: location,
        page_title: title,
        page_path: path,
    });
}
